import Swiper, { Navigation } from 'swiper'

Swiper.use([Navigation])

const twitterSlider = new Swiper('.swiper', {
  spaceBetween: 16,
  slidesPerView: 'auto',
  navigation: {
    prevEl: ".swiper-prev",
    nextEl: ".swiper-next",
  },
})


let twitterSliderMobile = null
if (document.querySelector('.twitter-collection-mobile')) {
  initMobile()

  window.addEventListener('resize', initMobile)
}

function initMobile () {
  if (window.innerWidth < 1024) {
    twitterSliderMobile = new Swiper ('.twitter-collection-mobile', {
      spaceBetween: 16,
      slidesPerView: 'auto',
      
    })
  } else {
    if (twitterSliderMobile) twitterSliderMobile.destroy()
  }
}
